import { type FC } from 'react'
import { InfoTooltip } from './InfoTooltip'

export const EventTypesInfoTooltip: FC = () => (
  <InfoTooltip
    label='About event types'
    content={
      <div className='d-flex flex-column gap-1 text-start'>
        <span className='bold'>Event types vs. Meeting types</span>
        <span>
          Event types control what clients can book through Scheduling. Meeting types control how your AI Assistant takes notes. Connect an Event type to a
          Meeting type so each booking captures the right notes.
        </span>
      </div>
    }
  />
)
